import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRotateLeftRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowRotateLeftRight"><Path fillRule="evenodd" clipRule="evenodd" d="M6 3V5.24408C7.60762 3.84651 9.72323 3 12 3C16.9706 3 21 7.02944 21 12V13H19V12C19 8.13401 15.866 5 12 5C10.0899 5 8.32434 5.76379 7.04285 7H10V9H4V3H6ZM5 11V12C5 15.866 8.13401 19 12 19C13.9101 19 15.6757 18.2362 16.9571 17H14.0118V15H20.0118V21H18.0118V18.7456C16.4028 20.1493 14.2824 21 12 21C7.02944 21 3 16.9706 3 12V11H5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowRotateLeftRight;
